module.exports = __webpack_public_path__ + "files/a10c21ab23e285118a371f522e273d5e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/logo_compact.png
 ** module id = 817
 ** module chunks = 0
 **/